export default __webpack_public_path__ + "static/media/vincennes.0b6a6c64.jpg";